import loadingTextBundle from '../i18n_js/loadingTextBundle';
import { loadLocalizers } from '../locale/I18nLoader';
export const embeddedBundle = loadLocalizers(loadingTextBundle, navigator.languages);
